import {
  CellFocusedEvent,
  ColDef,
  FirstDataRenderedEvent,
  GridOptions,
  RowDataUpdatedEvent,
} from 'ag-grid-enterprise';
import { GridLoadingOverlay } from './shared/cell-renderers/loading-overlay/loading-overlay.component';
import { GridNoRowsOverlay } from './shared/cell-renderers/no-rows-overlay/no-rows-overlay.component';

export const useOldTimeZoneSolution = true;
export const timeZone = useOldTimeZoneSolution
  ? 'Europe/London'
  : Intl.DateTimeFormat().resolvedOptions().timeZone;
export const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const dateFormat = 'MMM DD, YYYY'; // Sep 13, 2025
export const dateTimeFormat = 'MMM DD, YYYY, HH:mm'; // Sep 13, 2025, 06:00
export const maxFileSizeInBytes = 100000000;
export const complexities = [
  {
    label: 'Basic',
    value: 'basic',
    info: 'Minimal details required. Quick to assign and complete.',
    duration: {
      count: 1,
      unit: 'hour',
    },
  },
  {
    label: 'Standard',
    value: 'standard',
    info: 'Moderate level of details. Standard effort expected.',
    duration: {
      count: 2,
      unit: 'hours',
    },
  },
  {
    label: 'Complex',
    value: 'complex',
    info: 'High level of details. Requires careful handling. Best for experienced staff.',
    duration: {
      count: 4,
      unit: 'hours',
    },
  },
];

/*
  Grid Options
*/
export const GridDefaultColDef: ColDef = {
  menuTabs: ['generalMenuTab', 'filterMenuTab'],
  resizable: true,
  sortable: true,
  floatingFilter: false,
  enableCellChangeFlash: false,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  autoHeight: false,
  wrapText: false,
};

export const GridDefaultOptions: GridOptions = {
  loading: true,
  onFirstDataRendered: (event: FirstDataRenderedEvent) => {
    event.api.setGridOption('loading', false);
  },
  onRowDataUpdated: (event: RowDataUpdatedEvent<unknown>) => {
    event.api.setGridOption('loading', false);
  },
  loadingOverlayComponent: GridLoadingOverlay,
  noRowsOverlayComponent: GridNoRowsOverlay,
  suppressNoRowsOverlay: false,
  rowSelection: {
    mode: 'singleRow',
    enableClickSelection: true,
    checkboxes: false,
  },
  tooltipMouseTrack: true,
  cellSelection: false,
  blockLoadDebounceMillis: 0,
  pagination: true,
  paginationAutoPageSize: true,
  paginationPageSize: 25,
  tooltipShowDelay: 0,
  singleClickEdit: true,
  suppressColumnVirtualisation: true,
  suppressCellFocus: true,
  stopEditingWhenCellsLoseFocus: true,
  onCellFocused: (event: CellFocusedEvent<any, any>) => {
    const cellsToStop = event.api.getEditingCells();
    if (cellsToStop.length > 0) {
      event.api.stopEditing();
    }
  },
  suppressContextMenu: true,
  animateRows: false,
  suppressHorizontalScroll: false,
  enableCellTextSelection: true,
};
